import axios from 'utils/axios';
import type { GetClientListResultType } from '@econtractor/types';

export interface ClientListParams {
    page?: number;
    onPage?: number;
    search?: string;
    order?: string;
    status?: number[] | null;
}

export interface ClientPayload {
    clientName?: string;
    clientEmail?: string;
    clientPhone?: string;
    clientAddress?: string;
    clientLocation?: string;
    clientDescription?: string;
    clientStatus?: number;
}

export const getAllClients = async () => {
    try {
        const response = await axios('/clients/all');
        return response?.data || null;
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const getList = async (getData: ClientListParams): Promise<GetClientListResultType | null> => {
    try {
        const response = await axios('/clients', { params: getData });
        return response?.data || null;
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const getClientById = async (clientId: number | string) => {
    try {
        const response = await axios(`/clients/${clientId}`);
        return response?.data || null;
    } catch (e) {
        console.error(e);
        return null;
    }
};

export type CreateClientResult =
    | { ok: true; clientId: number }
    | { ok: false; errCode?: string };

export const createClient = async (createData: ClientPayload): Promise<CreateClientResult> => {
    try {
        const response = await axios.post('/clients/new', createData);
        const clientId = response?.data?.clientId;
        if (!clientId) return { ok: false };
        return { ok: true, clientId };
    } catch (e: any) {
        const errCode = e?.errCode;
        if (errCode) return { ok: false, errCode };
        console.error(e);
        return { ok: false };
    }
};

export const updateClient = async (clientId: number | string, clientData: ClientPayload) => {
    try {
        const response = await axios.post(`/clients/${clientId}`, clientData);
        return response?.data?.stat || false;
    } catch (e) {
        console.error(e);
        return false;
    }
};

export const deleteClient = async (clientId: number | string) => {
    try {
        const response = await axios.delete(`/clients/${clientId}`);
        return response?.data?.stat || false;
    } catch (e) {
        console.error(e);
        return false;
    }
};

export const setClientField = async (
    clientId: number | string,
    fieldName: string,
    fieldValue: string,
) => {
    try {
        const response = await axios.post(`/clients/field/${clientId}`, { fieldName, fieldValue });
        return response?.data?.stat || false;
    } catch (e) {
        console.error(e);
        return false;
    }
};
